import { render, staticRenderFns } from "./VueResizeable.vue?vue&type=template&id=ecc8a0a2&scoped=true&"
import script from "./VueResizeable.vue?vue&type=script&lang=js&"
export * from "./VueResizeable.vue?vue&type=script&lang=js&"
import style0 from "./VueResizeable.vue?vue&type=style&index=0&id=ecc8a0a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecc8a0a2",
  null
  
)

export default component.exports